/* ------------------------------------------ GRYFF COLUMN CHOOSER 29.05.2017 ----------------------------------------- */
/* ------------------------------------------------ UPDATED 23.12.2018 ------------------------------------------------ */
import utils from '@/app/utils/gfUtils';

(function (jQuery) {
  jQuery.gfColumnChooser = function (element, options) {
    const defaults = {
      type: 'modal',
      row: undefined,
      onSelected: function (type) {},
    };

    const $icon = {
      desktop: utils.chooseResponsiveIcon('desktop'),
      laptop: utils.chooseResponsiveIcon('laptop'),
      tablet: utils.chooseResponsiveIcon('tablet'),
      mobile: utils.chooseResponsiveIcon('mobile'),
    };

    this.settings = {};

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');

    const $element = jQuery(element);
    const $columnResizerPlaceholder = $gfLeftSideBar.find('#column_size_resizer');

    let _pressed = false;
    const _this = this;

    //Hide title of the block
    $element.closest('.gfSettingGroup').find('.gfSGTitleBar').css('display', 'none');

    //Column layout chooser for desktop
    let _mdColumnType = '<p class="size-layout desktop-layout">' + $icon.desktop + ' Desktop Layout</p>';
    _mdColumnType +=
      '<div class="gf_column-type">' +
      '<div class="select-type"> <div class="gf_row"> <div class="gf_col-xs-4 gf_column"> <button class="button active" data-cells="12"> <span class="column-12"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="6+6"> <span class="column-6"></span> <span class="column-6"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="4+4+4"> <span class="column-4"></span> <span class="column-4"></span> <span class="column-4"></span> </button> </div> </div> <div class="gf_row"> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="3+3+3+3"> <span class="column-3"></span> <span class="column-3"></span> <span class="column-3"></span> <span class="column-3"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="8+4"> <span class="column-8"></span> <span class="column-4"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="4+8"> <span class="column-4"></span> <span class="column-8"></span> </button> </div> </div> <div class="gf_row"> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="3+9"> <span class="column-3"></span> <span class="column-9"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="9+3"> <span class="column-9"></span> <span class="column-3"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="6+3+3"> <span class="column-6"></span> <span class="column-3"></span> <span class="column-3"></span> </button> </div> </div> <div class="gf_row"> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="3+3+6"> <span class="column-3"></span> <span class="column-3"></span> <span class="column-6"></span> </button> </div> <div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="3+6+3"> <span class="column-3"></span> <span class="column-6"></span> <span class="column-3"></span> </button> </div><div class="gf_col-xs-4 gf_column"> <button class="button custom-size" data-cells=""><div class="custom-column-size-holder"></div><svg aria-hidden="true" data-prefix="fas" data-icon="cog" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-cog fa-w-16 fa-2x"><path d="M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z" class=""></path></svg></span> </button> </div> </div> </div></div>';

    //current editting row
    let $activeRow;

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      if (_this.settings.row != undefined) {
        $activeRow = _this.settings.row;

        $columnResizerPlaceholder.hide();

        $element.hide();
        $element.after(_mdColumnType); //Show columns chooser for desktop

        //Undo and redo desktop layout changing
        $element.off('undo-redo-update').on('undo-redo-update', function () {
          const value = $element.attr('value');

          const $gfColumnType = $element.closest('.gfSGSettings').find('.select-type').first();

          $gfColumnType.find('button').removeClass('active');
          $gfColumnType.find('button[data-cells="' + value + '"]').addClass('active');

          if ($gfColumnType.find('button.active').length == 0)
            $gfColumnType.find('button.custom-size').addClass('active');

          if ($activeRow.data('gfrow') != undefined) {
            $activeRow.data('gfrow').setRowLayout(value);
          }

          //Set actual column size. For desktop, we must set two times, one by setRowLayout() and one like below
          if ($activeRow.data('gfrow')) {
            $activeRow.children('.gf_column').each(function (i, el) {
              $activeRow.data('gfrow').setColumn(jQuery(el), 'size', 'lg', value.split('+')[i]);
            });
          }

          _this.restoreColumnSize('md');
          _this.restoreColumnSize('sm');
          _this.restoreColumnSize('xs');

          _this.renderResponsiveLayout();
        });

        //Read desktop layout from previous editing session
        if ($activeRow.data('gfrow') != undefined) {
          const rowTypeString = _this.getRowLayout();

          const $gfColumnType = $element.closest('.gfSGSettings').find('.select-type');

          // init
          $gfColumnType.find('button').removeClass('active');
          $gfColumnType.find('.form-type input[type="text"]').val(rowTypeString).attr('value', rowTypeString);

          if ($gfColumnType.find('button[data-cells="' + rowTypeString + '"]').length != 0) {
            $gfColumnType.find('button[data-cells="' + rowTypeString + '"]').addClass('active');
          } else {
            $gfColumnType.find('button.custom-size').addClass('active');
          }
        }

        _this.renderResponsiveLayout();
      }

      return false;
    };

    //Manage resizable column layout for desktop, other screen size will follow this layout
    this.customColumnResizerController = function () {
      let startX, startWidth, totalWidth, $handle, $handleNext, currentValue, nextValue, delta;

      //Width of an 1-width column
      let elementWidth;
      //Use timeout to make the form less laggy
      let mouseMoveTimeout;
      let screenType;
      let cText = '';
      let extra = {};
      let isChanged = false;

      const $parentColumnChooseAdvanced = $columnResizerPlaceholder.closest('.gfSettingGroup');

      $parentColumnChooseAdvanced
        .off('mousemove')
        .off('mouseup')
        .off('mousedown')
        .on({
          mousemove: function (event) {
            if (_pressed) {
              $gfLeftSideBar.find('.table-resizable').css('cursor', 'col-resize');

              //Width of elements in the left and right of the resize handler
              currentValue = parseInt($handle.html());
              nextValue = parseInt($handleNext.html());
              totalWidth = currentValue + nextValue;

              delta = Math.round((startWidth + (event.pageX - startX)) / elementWidth) - currentValue;
              currentValue = currentValue + delta;

              //Update number on button
              if (currentValue > 0 && currentValue < totalWidth) {
                $handle.html(currentValue);
                $handleNext.html(totalWidth - currentValue);
              }

              if (delta != 0) {
                cText = '';
                if (!isChanged) {
                  isChanged = true;

                  //Backup current status
                  extra = {
                    rowSettings: [],
                    oldRowLayout: [],
                    newRowLayout: [],
                    oldScreen: '',
                    newScreen: '',
                  };

                  extra.oldRowLayout.push($element.val());
                  extra.oldRowLayout.push(_this.getColumnSizeByScreen('md'));
                  extra.oldRowLayout.push(_this.getColumnSizeByScreen('sm'));
                  extra.oldRowLayout.push(_this.getColumnSizeByScreen('xs'));

                  extra.oldScreen = $gfResTool.data('gfrestool').getCurrentStatus();

                  //Change screen size
                  if ($gfResTool.data('gfrestool') && $gfResTool.data('gfrestool').getCurrentStatus() != screenType) {
                    $gfResTool.data('gfrestool').resizeScreen(screenType);
                    $gfResTool.data('gfrestool').setCurrentStatus(screenType);
                    $gfResTool.find('.select-screen-inner .' + screenType).trigger('click'); //Change screen sign to desktop
                  }
                }

                //Change button width on the resizable form, also update the actual column width on desktop
                $handle
                  .closest('.resizable-columns-form')
                  .find('th')
                  .each(function (i, el) {
                    jQuery(el)
                      .removeClass(
                        'gf_col-xs-1 ' +
                          'gf_col-xs-2 ' +
                          'gf_col-xs-3 ' +
                          'gf_col-xs-4 ' +
                          'gf_col-xs-5 ' +
                          'gf_col-xs-6 ' +
                          'gf_col-xs-7 ' +
                          'gf_col-xs-8 ' +
                          'gf_col-xs-9 ' +
                          'gf_col-xs-10 ' +
                          'gf_col-xs-11 ' +
                          'gf_col-xs-12',
                      )
                      .addClass('gf_col-xs-' + jQuery(el).html());
                    _this.updateColumnSizeExtra(jQuery(el), parseInt(jQuery(el).html()), screenType);
                    cText += jQuery(el).html() + '+';
                  });

                //cText now will be new layout, for example 4+7+1
                cText = cText.substr(0, cText.length - 1);

                clearTimeout(mouseMoveTimeout);
                mouseMoveTimeout = setTimeout(function () {
                  const newColumnSize = cText.split('+');
                  if ($activeRow.children('.gf_column').length == 4 && newColumnSize.length == 2)
                    $activeRow.children('.gf_column').each(function (i, el) {
                      _this.updateColumnSizeExtra(jQuery(el), cText.split('+')[i % 2], screenType);
                    });
                  else
                    $activeRow.children('.gf_column').each(function (i, el) {
                      _this.updateColumnSizeExtra(jQuery(el), cText.split('+')[i], screenType);
                    });
                }, 100);
              }
            }
          },
          mouseup: function () {
            if (_pressed) {
              _pressed = false;
              if (isChanged) {
                isChanged = false;

                const lgColumnSize = _this.getColumnSizeByScreen('lg');
                const mdColumnSize = _this.getColumnSizeByScreen('md');
                const smColumnSize = _this.getColumnSizeByScreen('sm');
                const xsColumnSize = _this.getColumnSizeByScreen('xs');

                $element
                  .val(lgColumnSize)
                  .attr('value', lgColumnSize)
                  .trigger('row-layout-change')
                  .trigger('input-change');
                $gfLeftSideBar
                  .find('#gf_row-layout-md')
                  .val(mdColumnSize)
                  .attr('value', mdColumnSize)
                  .trigger('row-layout-change')
                  .trigger('input-change');
                $gfLeftSideBar
                  .find('#gf_row-layout-sm')
                  .val(smColumnSize)
                  .attr('value', smColumnSize)
                  .trigger('row-layout-change')
                  .trigger('input-change');
                $gfLeftSideBar
                  .find('#gf_row-layout-xs')
                  .val(xsColumnSize)
                  .attr('value', xsColumnSize)
                  .trigger('row-layout-change')
                  .trigger('input-change');

                //Set active button
                let newLayout;
                let $buttonHolder;
                if (screenType == 'lg') {
                  $buttonHolder = $element.next().next();
                  newLayout = lgColumnSize;
                } else if (screenType == 'md') {
                  $buttonHolder = $gfLeftSideBar.find('.laptop-layout-chooser').first();
                  newLayout = mdColumnSize;
                } else if (screenType == 'sm') {
                  $buttonHolder = $gfLeftSideBar.find('.tablet-layout-chooser').first();
                  newLayout = smColumnSize;
                } else {
                  $buttonHolder = $gfLeftSideBar.find('.mobile-layout-chooser').first();
                  newLayout = xsColumnSize;
                }

                _this.renderCustomSizeHolder(screenType);

                $buttonHolder.find('.select-type button').removeClass('active');
                $buttonHolder.find('.select-type button').each(function (i, el) {
                  if (
                    (jQuery(el).data('cells') && jQuery(el).data('cells') == newLayout) ||
                    jQuery(el).hasClass('custom-size')
                  ) {
                    jQuery(el).addClass('active');
                    return false;
                  }
                });

                extra.newRowLayout.push($element.val());
                extra.newRowLayout.push(_this.getColumnSizeByScreen('md'));
                extra.newRowLayout.push(_this.getColumnSizeByScreen('sm'));
                extra.newRowLayout.push(_this.getColumnSizeByScreen('xs'));

                extra.newScreen = $gfResTool.data('gfrestool').getCurrentStatus();

                $gryffEditor.data('gfhistory').addHistory('column-chooser', $activeRow.data('id'), extra);
              }

              $gfLeftSideBar.find('.table-resizable').css('cursor', 'initial');
              _this.removeIframeMask();

              if (screenType == 'lg') _this.renderResponsiveLayout();
            }
          },
        });

      $parentColumnChooseAdvanced.on('mousedown', '.table-resizable th', function (event) {
        $handle = jQuery(this);
        $handleNext = $handle.next('th');
        _pressed = true;
        startX = event.pageX;
        startWidth = $handle.width();
        elementWidth = $gfLeftSideBar.find('.desktop-layout-chooser .resizable-columns-form').width() / 12;
        const $screenTypeHolder = $handle.closest('.layout-chooser');
        if ($screenTypeHolder.hasClass('desktop-layout-chooser')) screenType = 'lg';
        else if ($screenTypeHolder.hasClass('laptop-layout-chooser')) screenType = 'md';
        else if ($screenTypeHolder.hasClass('tablet-layout-chooser')) screenType = 'sm';
        else screenType = 'xs';

        //Iframe mask fix a bug when mouse move to iframe area
        _this.addIframeMask();
      });

      //Set column size on resizable column form
      $gfLeftSideBar.find('.resizable-columns-form th').each(function (i, el) {
        jQuery(el)
          .removeClass(
            'gf_col-xs-1 ' +
              'gf_col-xs-2 ' +
              'gf_col-xs-3 ' +
              'gf_col-xs-4 ' +
              'gf_col-xs-5 ' +
              'gf_col-xs-6 ' +
              'gf_col-xs-7 ' +
              'gf_col-xs-8 ' +
              'gf_col-xs-9 ' +
              'gf_col-xs-10 ' +
              'gf_col-xs-11 ' +
              'gf_col-xs-12',
          )
          .addClass('gf_col-xs-' + jQuery(el).html());
      });
    };

    //Display suggest responsive layout based on desktop screen layout
    this.renderResponsiveLayout = function () {
      let values = [];
      if ($activeRow.data('gfrow') != undefined) values = _this.getRowLayout().split('+');

      // Laptop Layout
      let columnSizeChooser =
        '<div class="gf_column-type layout-chooser laptop-layout-chooser"><p class="size-layout laptop-layout">' +
        $icon.laptop +
        ' Laptop Layout</p><div class="select-type"> <div class="gf_row">';

      columnSizeChooser +=
        '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="' +
        values
          .map(function (value) {
            return 12;
          })
          .join('+') +
        '"> <span class="column-12"></span> </button> </div>';

      if (values.length == 4)
        columnSizeChooser +=
          '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="6+6+6+6"> <span class="column-6"></span> <span class="column-6"></span> </button> </div>';

      if (values.length > 1)
        columnSizeChooser +=
          '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="' +
          values.join('+') +
          '">' +
          values
            .map(function (value) {
              return '<span class="column-' + value + '"></span>';
            })
            .join('') +
          '</button> </div>';

      columnSizeChooser +=
        '<div class="gf_col-xs-4 gf_column"> <button class="button custom-size" data-cells=""><div class="custom-column-size-holder"></div><svg aria-hidden="true" data-prefix="fas" data-icon="cog" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-cog fa-w-16 fa-2x"><path d="M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z" class=""></path></svg> </button> </div>';
      columnSizeChooser += '</div></div></div>';

      //Tablet Layout
      columnSizeChooser +=
        '<div class="gf_column-type layout-chooser tablet-layout-chooser"><p class="size-layout tablet-layout">' +
        $icon.tablet +
        ' Tablet Layout</p><div class="select-type"> <div class="gf_row">';

      columnSizeChooser +=
        '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="' +
        values
          .map(function (value) {
            return 12;
          })
          .join('+') +
        '"> <span class="column-12"></span> </button> </div>';

      if (values.length == 4) {
        columnSizeChooser +=
          '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="6+6+6+6"> <span class="column-6"></span> <span class="column-6"></span> </button> </div>';
      }

      if (values.length > 1)
        columnSizeChooser +=
          '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="' +
          values.join('+') +
          '">' +
          values
            .map(function (value) {
              return '<span class="column-' + value + '"></span>';
            })
            .join('') +
          '</button> </div>';

      columnSizeChooser +=
        '<div class="gf_col-xs-4 gf_column"> <button class="button custom-size" data-cells=""><div class="custom-column-size-holder"></div><svg aria-hidden="true" data-prefix="fas" data-icon="cog" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-cog fa-w-16 fa-2x"><path d="M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z" class=""></path></svg> </button> </div>';
      columnSizeChooser += '</div></div></div>';

      //Mobile Layout
      columnSizeChooser +=
        '<div class="gf_column-type layout-chooser mobile-layout-chooser"><p class="size-layout mobile-layout">' +
        $icon.mobile +
        ' Mobile Layout</p><div class="select-type"> <div class="gf_row">';

      columnSizeChooser +=
        '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="' +
        values
          .map(function (value) {
            return 12;
          })
          .join('+') +
        '"> <span class="column-12"></span> </button> </div>';

      if (values.length == 4) {
        columnSizeChooser +=
          '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="6+6+6+6"> <span class="column-6"></span> <span class="column-6"></span> </button> </div>';
      }

      if (values.length > 1)
        columnSizeChooser +=
          '<div class="gf_col-xs-4 gf_column"> <button class="button" data-cells="' +
          values.join('+') +
          '">' +
          values
            .map(function (value) {
              return '<span class="column-' + value + '"></span>';
            })
            .join('') +
          '</button> </div>';

      columnSizeChooser +=
        '<div class="gf_col-xs-4 gf_column"> <button class="button custom-size" data-cells=""><div class="custom-column-size-holder"></div><svg aria-hidden="true" data-prefix="fas" data-icon="cog" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-cog fa-w-16 fa-2x"><path d="M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z" class=""></path></svg> </button> </div>';
      columnSizeChooser += '</div></div></div>';

      //Remove old stuff and re-render
      $gfLeftSideBar.find('.gfSGSettings .layout-chooser').remove();
      $gfLeftSideBar.find('.select-type').closest('.gfSGSettings').find('.gf_column-type').after(columnSizeChooser);

      _this.renderCustomSizeHolder('lg');
      _this.renderCustomSizeHolder('md');
      _this.renderCustomSizeHolder('sm');
      _this.renderCustomSizeHolder('xs');

      //Set active layout on different screen sizes
      $gfLeftSideBar.find('.layout-chooser .gf_column button').removeClass('active');
      $gfLeftSideBar.find('.layout-chooser .gf_row').each(function (i, el) {
        let screenType = '';
        if (i == 0) screenType = 'md';
        else if (i == 1) screenType = 'sm';
        else screenType = 'xs';

        const value = _this.getColumnSizeByScreen(screenType);

        $gfLeftSideBar
          .find('#gf_row-layout-' + screenType)
          .attr('value', value)
          .val(value)
          .trigger('input-change');

        jQuery(el)
          .find('button')
          .each(function (i, e) {
            if ((jQuery(e).data('cells') && jQuery(e).data('cells') == value) || jQuery(e).hasClass('custom-size')) {
              jQuery(e).addClass('active');
              return false;
            }
          });
      });

      const $currentActiveButton = jQuery('#gf_row-layout').closest('.gfSGSettings').find('button.active').eq(0);
      const cells = $currentActiveButton.data('cells') != undefined ? $currentActiveButton.data('cells') : '12';

      if (cells == '12') {
        $gfLeftSideBar.find('.layout-chooser').css('display', 'none');
      } else {
        $gfLeftSideBar.find('.layout-chooser').css('display', 'initial');
      }

      _this.renderColumnResizer();
      _this.applyEvents();
    };

    this.renderCustomSizeHolder = function (screenType) {
      let $customSizeHolder;
      const customSize = _this.convertLayoutSize(_this.getColumnSizeByScreen(screenType)).split('+');

      if (screenType == 'lg') {
        $customSizeHolder = $element.next().next().find('.custom-column-size-holder');
      } else if (screenType == 'md') {
        $customSizeHolder = $gfLeftSideBar.find('.laptop-layout-chooser').first().find('.custom-column-size-holder');
      } else if (screenType == 'sm') {
        $customSizeHolder = $gfLeftSideBar.find('.tablet-layout-chooser').first().find('.custom-column-size-holder');
      } else {
        $customSizeHolder = $gfLeftSideBar.find('.mobile-layout-chooser').first().find('.custom-column-size-holder');
      }

      $customSizeHolder.html(
        customSize
          .map(function (value) {
            return '<span class="column-' + value + '"></span>';
          })
          .join(''),
      );
    };

    //Convert layout size to single row layout, example 12+12 => 12
    this.convertLayoutSize = function (layout) {
      const sizes = layout.split('+');
      if (sizes[0] == '12') return '12';
      else if (sizes[1] && parseInt(sizes[0]) + parseInt(sizes[1]) == 12) return sizes[0] + '+' + sizes[1];
      else return layout;
    };

    //Render column resizer)
    this.renderColumnResizer = function () {
      // Desktop Layout
      let columnSizeChooser =
        '<div class="gf_column-type layout-chooser desktop-layout-chooser"><p class="size-layout desktop-layout">' +
        $icon.desktop +
        ' Desktop Layout</p><div class="select-type">';

      //Column Size Resizer
      var values = _this.convertLayoutSize(_this.getColumnSizeByScreenFixed('lg')).split('+');

      columnSizeChooser +=
        '<div class="gf_column-type resizable-columns-form">' +
        '<table class="table table-resizable">' +
        '<thead>' +
        '<tr>';

      for (var i = 0; i < values.length; i++) {
        columnSizeChooser += '<th class="gf_col-xs-' + values[i] + '">' + values[i] + '</th>';
      }

      columnSizeChooser += '</tr>' + '</thead>' + '</table>' + '</div>';

      columnSizeChooser += '</div></div>';

      // Laptop Layout
      columnSizeChooser +=
        '<div class="gf_column-type layout-chooser laptop-layout-chooser"><p class="size-layout laptop-layout">' +
        $icon.laptop +
        'Laptop Layout</p><div class="select-type">';

      //Column Size Resizer
      var values = _this.convertLayoutSize(_this.getColumnSizeByScreenFixed('md')).split('+');

      columnSizeChooser +=
        '<div class="gf_column-type resizable-columns-form">' +
        '<table class="table table-resizable">' +
        '<thead>' +
        '<tr>';

      for (var i = 0; i < values.length; i++) {
        columnSizeChooser += '<th class="gf_col-xs-' + values[i] + '">' + values[i] + '</th>';
      }

      columnSizeChooser += '</tr>' + '</thead>' + '</table>' + '</div>';

      columnSizeChooser += '</div></div>';

      //Tablet Layout
      columnSizeChooser +=
        '<div class="gf_column-type layout-chooser tablet-layout-chooser"><p class="size-layout tablet-layout">' +
        $icon.tablet +
        ' Tablet Layout</p><div class="select-type">';

      //Column Size Resizer
      var values = _this.convertLayoutSize(_this.getColumnSizeByScreenFixed('sm')).split('+');

      columnSizeChooser +=
        '<div class="gf_column-type resizable-columns-form">' +
        '<table class="table table-resizable">' +
        '<thead>' +
        '<tr>';

      for (var i = 0; i < values.length; i++) {
        columnSizeChooser += '<th class="gf_col-xs-' + values[i] + '">' + values[i] + '</th>';
      }

      columnSizeChooser += '</tr>' + '</thead>' + '</table>' + '</div>';

      columnSizeChooser += '</div></div>';

      //Mobile Layout
      columnSizeChooser +=
        '<div class="gf_column-type layout-chooser mobile-layout-chooser"><p class="size-layout mobile-layout">' +
        $icon.mobile +
        ' Mobile Layout</p><div class="select-type">';

      //Column Size Resizer
      var values = _this.convertLayoutSize(_this.getColumnSizeByScreenFixed('xs')).split('+');

      columnSizeChooser +=
        '<div class="gf_column-type resizable-columns-form">' +
        '<table class="table table-resizable">' +
        '<thead>' +
        '<tr>';

      for (var i = 0; i < values.length; i++) {
        columnSizeChooser += '<th class="gf_col-xs-' + values[i] + '">' + values[i] + '</th>';
      }

      columnSizeChooser += '</tr>' + '</thead>' + '</table>' + '</div>';

      columnSizeChooser += '</div></div>';

      //Re-render
      $columnResizerPlaceholder.nextAll('.layout-chooser').remove();
      $columnResizerPlaceholder.after(columnSizeChooser);
    };

    //Apply events when layout buttons clicked
    this.applyEvents = function () {
      const $gfColumnType = $element.closest('.gfSGSettings');

      if ($activeRow.data('gfrow') != undefined) {
        //When desktop layout buttons clicked, change desktop layout
        $gfColumnType
          .find('.select-type:first button:not(.custom-size):not(.active)')
          .off('click')
          .on('click', function () {
            if (!jQuery(this).hasClass('active')) {
              //Backup current status
              const extra = {
                rowSettings: [],
                oldRowLayout: [],
                newRowLayout: [],
                oldScreen: '',
                newScreen: '',
              };

              $activeRow.children('.gf_column').each(function () {
                const $column = jQuery(this);
                const index = $column.index();

                $column.children('div').each(function () {
                  const $mer = jQuery(this);
                  if ($mer.hasClass('gf_row') || $mer.hasClass('module-wrap') || $mer.hasClass('element-wrap')) {
                    const item = {
                      id: $mer.attr('id'),
                      index: index,
                    };
                    extra.rowSettings.push(item);
                  }
                });
              });

              extra.oldRowLayout.push($element.val());
              extra.oldRowLayout.push(_this.getColumnSizeByScreen('md'));
              extra.oldRowLayout.push(_this.getColumnSizeByScreen('sm'));
              extra.oldRowLayout.push(_this.getColumnSizeByScreen('xs'));

              extra.oldScreen = $gfResTool.data('gfrestool').getCurrentStatus();

              $gfColumnType.find('.select-type button.active').removeClass('active');

              if ($gfResTool.data('gfrestool') && $gfResTool.data('gfrestool').getCurrentStatus() != 'lg') {
                $gfResTool.data('gfrestool').resizeScreen('lg');
                $gfResTool.data('gfrestool').setCurrentStatus('lg');
                $gfResTool.find('.select-screen-inner .lg').trigger('click');
              }

              jQuery(this).addClass('active');

              const value = jQuery(this).attr('data-cells');
              const cText = value.replace(/\s+/g, '');

              $element.val(cText).attr('value', cText).trigger('row-layout-change').trigger('input-change');

              $activeRow.data('gfrow').setRowLayout(cText);

              _this.resetColumnSize(cText);

              extra.newRowLayout.push($element.val());
              extra.newRowLayout.push(_this.getColumnSizeByScreen('md'));
              extra.newRowLayout.push(_this.getColumnSizeByScreen('sm'));
              extra.newRowLayout.push(_this.getColumnSizeByScreen('xs'));

              extra.newScreen = $gfResTool.data('gfrestool').getCurrentStatus();

              $gryffEditor.data('gfhistory').addHistory('column-chooser', $activeRow.data('id'), extra);

              _this.renderResponsiveLayout();
            }
          });

        //Responsive layout manager
        const $layoutChooser = $gfLeftSideBar.find('.layout-chooser');

        $layoutChooser
          .find('.select-type button')
          .off('click')
          .on('click', function () {
            if (!jQuery(this).hasClass('active')) {
              jQuery(this).closest('.select-type').find('button.active').removeClass('active');
              jQuery(this).addClass('active');

              const screenTypeHolder = jQuery(this).closest('.layout-chooser').attr('class');
              let screenType;

              if (screenTypeHolder.includes('mobile-layout-chooser')) screenType = 'xs';
              else if (screenTypeHolder.includes('tablet-layout-chooser')) screenType = 'sm';
              else if (screenTypeHolder.includes('laptop-layout-chooser')) screenType = 'md';
              else screenType = 'lg';

              const cText = jQuery(this).data('cells') + '';

              const currentResponsiveLayout = cText.split('+');

              // column positions for undo / redo
              const extra = {
                oldRowLayout: [],
                newRowLayout: [],
                oldScreen: '',
                newScreen: '',
                rowSettings: [],
              };

              extra.oldRowLayout.push($element.val());
              extra.oldRowLayout.push(_this.getColumnSizeByScreen('md'));
              extra.oldRowLayout.push(_this.getColumnSizeByScreen('sm'));
              extra.oldRowLayout.push(_this.getColumnSizeByScreen('xs'));

              extra.oldScreen = $gfResTool.data('gfrestool').getCurrentStatus();

              //Change screen size
              if ($gfResTool.data('gfrestool') && $gfResTool.data('gfrestool').getCurrentStatus() != screenType) {
                $gfResTool.data('gfrestool').resizeScreen(screenType);
                $gfResTool.data('gfrestool').setCurrentStatus(screenType);
                $gfResTool.find('.select-screen-inner .' + screenType).trigger('click'); //Change screen size display
              }

              $activeRow.children('.gf_column').each(function (i, el) {
                _this.updateColumnSizeExtra(jQuery(el), currentResponsiveLayout[i], screenType);
              });

              jQuery('#gf_row-layout-' + screenType)
                .val(cText)
                .attr('value', cText)
                .trigger('input-change');
              //    .trigger('history-change');

              extra.newRowLayout.push($element.val());
              extra.newRowLayout.push(_this.getColumnSizeByScreen('md'));
              extra.newRowLayout.push(_this.getColumnSizeByScreen('sm'));
              extra.newRowLayout.push(_this.getColumnSizeByScreen('xs'));

              extra.newScreen = $gfResTool.data('gfrestool').getCurrentStatus();

              $gryffEditor.data('gfhistory').addHistory('column-chooser', $activeRow.data('id'), extra);

              _this.renderColumnResizer();
            }
          });

        //Custom column resizer controller
        _this.customColumnResizerController();
      }

      return false;
    };

    //Reset columns size when desktop layout buttons clicked
    this.resetColumnSize = function (cText) {
      if ($activeRow.data('gfrow')) {
        const columnSizeHolder = $activeRow.children('.gf_column');
        switch (cText) {
          case '12':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-12 gf_col-md-12 gf_col-sm-12 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('12').attr('value', '12').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('12').attr('value', '12').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12').attr('value', '12').trigger('input-change');
            break;
          case '6+6':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-6 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('6+6').attr('value', '6+6').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('6+6').attr('value', '6+6').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12').attr('value', '12+12').trigger('input-change');
            break;
          case '4+4+4':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-12 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('4+4+4').attr('value', '4+4+4').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            break;
          case '3+3+3+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');
            columnSizeHolder.eq(3).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-6 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('3+3+3+3').attr('value', '3+3+3+3').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('6+6+6+6').attr('value', '6+6+6+6').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12+12+12').attr('value', '12+12+12+12').trigger('input-change');
            break;
          case '8+4':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-8 gf_col-md-8 gf_col-sm-8 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-4 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('8+4').attr('value', '8+4').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('6+6').attr('value', '8+4').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12').attr('value', '12+12').trigger('input-change');
            break;
          case '4+8':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-4 gf_col-md-4 gf_col-sm-4 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-8 gf_col-md-8 gf_col-sm-8 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('4+8').attr('value', '4+8').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('6+6').attr('value', '4+8').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12').attr('value', '12+12').trigger('input-change');
            break;
          case '3+9':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-3 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-9 gf_col-md-9 gf_col-sm-9 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('3+9').attr('value', '3+9').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('6+6').attr('value', '3+9').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12').attr('value', '12+12').trigger('input-change');
            break;
          case '9+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-9 gf_col-md-9 gf_col-sm-9 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-3 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('9+3').attr('value', '9+3').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('6+6').attr('value', '9+3').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12').attr('value', '12+12').trigger('input-change');
            break;
          case '6+3+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('6+3+3').attr('value', '6+3+3').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            break;
          case '3+3+6':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-12 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('3+3+6').attr('value', '3+3+6').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            break;
          case '3+6+3':
            columnSizeHolder.eq(0).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(1).attr('class', 'gf_column gf_col-lg-6 gf_col-md-6 gf_col-sm-12 gf_col-xs-12');
            columnSizeHolder.eq(2).attr('class', 'gf_column gf_col-lg-3 gf_col-md-3 gf_col-sm-12 gf_col-xs-12');

            jQuery('#gf_row-layout-md').val('3+6+3').attr('value', '3+6+3').trigger('input-change');
            jQuery('#gf_row-layout-sm').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            jQuery('#gf_row-layout-xs').val('12+12+12').attr('value', '12+12+12').trigger('input-change');
            break;
        }
      }
    };

    //Restore responsive column row layout
    this.restoreColumnSize = function (screenType) {
      let size;
      if (screenType == 'lg') size = $gfLeftSideBar.find('#gf_row-layout').val().split('+');
      else
        size = $gfLeftSideBar
          .find('#gf_row-layout-' + screenType)
          .val()
          .split('+');

      if ($activeRow.data('gfrow')) {
        const columnSizeHolder = $activeRow.children('.gf_column');

        for (let i = 0; i < columnSizeHolder.length; i++) {
          columnSizeHolder
            .eq(i)
            .removeClass(
              'gf_col-' +
                screenType +
                '-1 ' +
                'gf_col-' +
                screenType +
                '-2 ' +
                'gf_col-' +
                screenType +
                '-3 ' +
                'gf_col-' +
                screenType +
                '-4 ' +
                'gf_col-' +
                screenType +
                '-5 ' +
                'gf_col-' +
                screenType +
                '-6 ' +
                'gf_col-' +
                screenType +
                '-7 ' +
                'gf_col-' +
                screenType +
                '-8 ' +
                'gf_col-' +
                screenType +
                '-9 ' +
                'gf_col-' +
                screenType +
                '-10 ' +
                'gf_col-' +
                screenType +
                '-11 ' +
                'gf_col-' +
                screenType +
                '-12',
            );
          columnSizeHolder.eq(i).addClass('gf_col-' + screenType + '-' + size[i]);
        }
      }
    };

    this.getColumnSizeByScreen = function (screenType) {
      let columnSize = '';
      $activeRow.children('.gf_column').each(function (i, el) {
        columnSize += _this.getColumnSize(jQuery(el), screenType) + '+';
      });
      return columnSize.substr(0, columnSize.length - 1);
    };

    //Return desktop layout, for example 3+5+4
    this.getRowLayout = function () {
      return $activeRow.data('gfrow').getRowLayout();
    };

    this.setRowLayout = function (cText) {
      return $activeRow.data('gfrow').setRowLayout(cText);
    };

    //Add a mask on top of iframe to fix a problem when drag resiazable column layout form
    this.addIframeMask = function () {
      $gfLeftSideBar.data('gfleftsidebar').onBackgroundIframe('iframeDropDownBody', true);

      setTimeout(function () {
        $gryffBody
          .find('.iframeDropDownBody')
          .off('mousedown.removeBackground')
          .on('mousedown.removeBackground', function () {
            $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('iframeDropDownBody', true);
          });
      }, 0);
    };

    //Remove mask on top of iframe when mouse drop
    this.removeIframeMask = function () {
      $gfLeftSideBar.data('gfleftsidebar').offBackgroundIframe('iframeDropDownBody', true);
    };

    //Set actual column to size (for example 6 => col-md-6)
    this.updateColumnSize = function ($that, size) {
      const screenType =
        $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

      // column size
      const thisColumnId = $that.attr('index');
      const $thisColumn = $activeRow.children('#c-' + thisColumnId);
      if ($activeRow.data('gfrow')) $activeRow.data('gfrow').setColumn($thisColumn, 'size', screenType, size);

      return false;
    };

    //Set actual column to size for different screen size
    this.updateColumnSizeExtra = function ($that, size, screenType) {
      if (size == undefined) return;

      if ($activeRow.data('gfrow')) {
        $that
          .removeClass(
            'gf_col-' +
              screenType +
              '-1 ' +
              'gf_col-' +
              screenType +
              '-2 ' +
              'gf_col-' +
              screenType +
              '-3 ' +
              'gf_col-' +
              screenType +
              '-4 ' +
              'gf_col-' +
              screenType +
              '-5 ' +
              'gf_col-' +
              screenType +
              '-6 ' +
              'gf_col-' +
              screenType +
              '-7 ' +
              'gf_col-' +
              screenType +
              '-8 ' +
              'gf_col-' +
              screenType +
              '-9 ' +
              'gf_col-' +
              screenType +
              '-10 ' +
              'gf_col-' +
              screenType +
              '-11 ' +
              'gf_col-' +
              screenType +
              '-12',
          )
          .addClass('gf_col-' + screenType + '-' + size);
        //$activeRow.data('gfrow').setColumn($thisColumn, 'size', screenType, size);
      }
      return false;
    };

    /* Extract actual column size from class name, for example col-md-6 => 6 */
    this.getColumnSize = function ($thisColumn, screenType) {
      var res = $activeRow.data('gfrow').getColumn($thisColumn, 'size', screenType);
      let value = 12;

      if (res.value == undefined) {
        // inherit from smaller screens
        const devices = ['xs', 'sm', 'md', 'lg'];
        let index = 0;
        for (var i = 0; i < devices.length; i++) {
          if (screenType == devices[i]) {
            index = i;
            break;
          }
        }
        for (var i = index; i < devices.length; i++) {
          var res = $activeRow.data('gfrow').getColumn($thisColumn, 'size', devices[i]);
          if (res.value != undefined) {
            value = res.value;
            break;
          } else {
            value = 12;
          }
        }
      } else {
        value = res.value;
      }
      return value;
    };

    this.getColumnSizeByScreenFixed = function (screenType) {
      if (screenType == 'lg') return $gfLeftSideBar.find('#gf_row-layout').val();
      return $gfLeftSideBar.find('#gf_row-layout-' + screenType).val();
    };

    this.init();
  };
  jQuery.fn.gfColumnChooser = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfcolumnchooser')) {
        const plugin = new jQuery.gfColumnChooser(this, options);
        jQuery(this).data('gfcolumnchooser', plugin);
      }
    });
  };
})(jQuery);
